import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectRequirementChangeApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-requirementchange'
  }

}